module.exports = __webpack_public_path__ + "images/marketing/survey2016-thumb.png";